import { render, staticRenderFns } from "./QVersionList.vue?vue&type=template&id=517a9ed6&scoped=true&"
import script from "./QVersionList.vue?vue&type=script&lang=js&"
export * from "./QVersionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517a9ed6",
  null
  
)

export default component.exports